const firebaseConfig = {
    apiKey: "AIzaSyC6gyDEIeP6rirqxiqGO8yKwd7DhaTdOwU",
    authDomain: "foodie-9a824.firebaseapp.com",
    projectId: "foodie-9a824",
    storageBucket: "foodie-9a824.appspot.com",
    messagingSenderId: "343941159236",
    appId: "1:343941159236:web:6c5f860366dbeee14ddf11"
};
export default firebaseConfig;